import React, { useState } from 'react';
import {
  Box,
  Paper,
  Typography,
  IconButton,
  Chip,
  Alert,
  LinearProgress,
} from '@mui/material';
import {
  Close as CloseIcon,
  Info as InfoIcon,
} from '@mui/icons-material';
import dayjs from 'dayjs';

const VideoPlayer = ({ session, onClose }) => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  return (
    <Paper sx={{ position: 'relative', backgroundColor: '#000' }}>
      {/* 헤더 */}
      <Box
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          zIndex: 10,
          background: 'linear-gradient(to bottom, rgba(0,0,0,0.8) 0%, transparent 100%)',
          p: 2,
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <Box>
          <Typography variant="h6" color="white">
            채널 {session.channel}
          </Typography>
          <Typography variant="caption" color="grey.300">
            {dayjs(session.start_time).format('YYYY년 MM월 DD일 HH:mm')} 부터
          </Typography>
        </Box>
        <Box>
          <Chip
            label="LIVE"
            color="error"
            size="small"
            sx={{ mr: 1 }}
            icon={<InfoIcon />}
          />
          <IconButton onClick={onClose} sx={{ color: 'white' }}>
            <CloseIcon />
          </IconButton>
        </Box>
      </Box>

      {/* MJPEG 스트림 */}
      <Box sx={{ position: 'relative', paddingTop: '56.25%' /* 16:9 비율 */ }}>
        <div style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}>
          <img
            src={`http://localhost:8000/api/stream/${session.id}/`}
            alt="NVR Stream"
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'contain',
            }}
            onLoad={() => setLoading(false)}
            onError={() => {
              setError('스트림을 로드할 수 없습니다.');
              setLoading(false);
            }}
          />
        </div>
        
        {/* 로딩 표시 */}
        {loading && (
          <Box
            sx={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              zIndex: 5,
              textAlign: 'center',
            }}
          >
            <LinearProgress sx={{ width: 200, mb: 2 }} />
            <Typography color="white">영상 로딩 중...</Typography>
          </Box>
        )}

        {/* 에러 표시 */}
        {error && (
          <Box
            sx={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              zIndex: 5,
              width: '80%',
            }}
          >
            <Alert severity="error" sx={{ backgroundColor: 'rgba(211, 47, 47, 0.9)' }}>
              {error}
            </Alert>
          </Box>
        )}
      </Box>

      {/* 정보 표시 */}
      <Box sx={{ p: 2, backgroundColor: 'grey.900' }}>
        <Typography variant="body2" color="grey.400">
          세션 ID: {session.id}
        </Typography>
        <Typography variant="body2" color="grey.400">
          채널: {session.channel}
        </Typography>
      </Box>
    </Paper>
  );
};

export default VideoPlayer; 